function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.213 18.2999C12.213 18.1999 12.213 18.1999 12.213 18.2999L6.98638 5.1999C6.87971 4.9999 6.66637 4.8999 6.34637 4.8999C6.13304 4.9999 6.02637 5.1999 6.02637 5.4999L11.1464 18.2999H12.213Z",
  fill: "#454852"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2102 17.5C12.1051 17.5 11.8949 17.5 11.7897 17.5C8.11027 17.5 4.32566 20.407 4.01028 21.8023C3.90515 22.5 4.64105 22.5 4.64105 22.5H19.3589C19.3589 22.5 20.0948 22.5 19.9897 21.8023C19.7795 20.407 15.8897 17.5 12.2102 17.5Z",
  fill: "#00E03B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5416 2.5C15.4359 2.5 15.4359 2.5 15.3302 2.5C13.3218 4.2561 10.7848 4.14634 10.6791 4.14634C8.03649 4.03659 6.34521 5.02439 6.2395 5.13415C6.1338 5.2439 6.13379 5.35366 6.13379 5.46342L8.2479 11.3902C8.2479 11.5 8.35361 11.5 8.35361 11.5C8.45932 11.5 8.45932 11.5 8.56502 11.5C8.56502 11.5 10.2563 10.5122 12.7932 10.622C12.899 10.622 14.1674 10.7317 15.753 10.0732C16.3872 9.85366 17.1272 9.41463 17.7614 8.86585C17.8671 8.7561 17.8671 8.64634 17.8671 8.64634L15.753 2.71951C15.6473 2.60976 15.6473 2.60976 15.5416 2.5Z",
  fill: "#178FFA"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8368 7.48113C11.8368 7.48113 14.477 7.59434 16.8005 5.89623L15.6387 2.61321C15.6387 2.5 15.5331 2.5 15.5331 2.5C15.4275 2.5 15.4275 2.5 15.3219 2.5C13.3153 4.31132 10.7807 4.19811 10.6751 4.19811C8.03478 4.08491 6.345 5.10377 6.23939 5.21698C6.13378 5.33019 6.13379 5.44339 6.13379 5.5566L7.1899 8.5C7.92917 7.93396 9.61893 7.36792 11.8368 7.48113Z",
  fill: "#41A0FF"
});

var SvgAwayWon = function SvgAwayWon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAwayWon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/awayWon.90a06576.svg";
export { ForwardRef as ReactComponent };